<template>
    <div>
        <h3 class="mm-color mb-3">{{$t('intern_objekte_anfragen.objekt_title')}}</h3>
        <div class="row">
            <div class="col-md-7 pb-2">
              <div class="form-group position-relative">
                <input type="text" class="form-control" name="searchQuery" v-model="search_query"  placeholder="Name, Firma, Inseratsnummer" v-on:keyup.enter="searchQuery()" />
                <font-awesome-icon icon="search" class="search mm-color" @click="searchQuery()"/>
              </div>
            </div>
            <div class="col-md-5 pb-2 float-right">
              <select v-model="sort_input" class=" form-control">
                <option value="1"> Sortieren: Neueste zuerst </option>
                <option value="0" >Sortieren: Älteste zuerst</option>
                <option value="2" >Sortieren: Ungelesene zuerst</option>
              </select>
            </div>
        </div>
        <div class="row" v-if="queries && queries.length > 0">
            <div class="col-12">
                <query-list-component :queries="queries"/>
            </div>
            <!--<div class="col-12 col-md-8" v-if="!isMobile">
                <query-preview-component />
            </div>
            <b-modal v-else
                ref="queryModal"
                centered
                size="lg"
                :static="true"
                title="Anfrage"
                :ok-only="true"
                ok-variant="success"
                @ok="emitEvent">
                <query-preview-component />
            </b-modal>-->
            <div class="col-12 mt-5">
                <pagination-component
                    :page="page"
                    :numOfPages="numOfPages"
                    :routePath="routePath"
                    :action="'QUERIES'"
                />
            </div>
        </div>
        <div v-else>
            <div class="alert alert-warning">
                {{$t('intern_objekte_anfragen.noch_keine_anfrage')}}
            </div>
        </div>
    </div>
</template>

<script>
    import QueryListComponent    from '../../components/queries/QueryList';
    import QueryFilterComponent  from '../../components/queries/QueryFilter';
    import PaginationComponent   from '../../components/shared/Pagination';
    import QueryPreviewComponent from '../../components/queries/QueryPreview';
    import { IsMobileMixin }     from '../../mixins/IsMobile';
    import EventBus              from '../../EventBus';

    export default {
        data() {
            return {
                queries: this.$store.state.queries,
                queries_copy : this.$store.state.queries,
                numOfPages: this.$store.state.numOfPagesForRequests,
                routePath: 'anfragen-einsehen',
                sort_input : 1,
                search_query : ''
            }
        },
        props: ['page'],
        watch: {
            page(val) {
                this.fetchQueries();
            },
            sort_input(val){
              this.queries = this.queries.sort((el1,el2) => {
                  const datetime1 = (new Date(el1.datetime_query).getTime() / 1000).toFixed(0);
                  const datetime2 = (new Date(el2.datetime_query).getTime() / 1000).toFixed(0);
                  if(datetime1 <datetime2 && val == 0)
                    return -1;
                  if(datetime1 > datetime2 && val == 1)
                    return -1;
                  if(el1.status == 'unread' && val == 2)
                    return -1;
                  return 0;
              });
            }
        },
        mixins: [IsMobileMixin],
        components: {
            QueryListComponent,
            QueryFilterComponent,
            QueryPreviewComponent,
            PaginationComponent
        },
        methods: {
            /*emitEvent() {
                EventBus.$emit('READ_QUERY', null);
                EventBus.$emit('ACTIVE_QUERY_TO_NULL', null);
            },
            showModal() {
                if(this.isMobile){
                    this.$refs.queryModal.show();
                }
            },*/
            fetchQueries() {
                this.$store.dispatch('QUERIES', this.page);
            },
            searchQuery(){
              this.$store.dispatch('QUERIES_BY_SEARCHVALUE', {page : this.page , search_query : this.search_query});
            }
        },
        created() {

            document.title = "Anfragen";

            this.fetchQueries();

            this.$store.watch(() => this.$store.getters.numOfPagesForRequests, numOfPages => {
                this.numOfPages = numOfPages;
            });
            this.$store.watch(() => this.$store.getters.queries, queries => {
                this.queries = queries;
                this.queries_copy = this.queries;
            });

            //EventBus.$on('READ_QUERY', this.showModal);
            EventBus.$on('DISPATCH_QUERIES', this.fetchQueries);

        },
        beforeDestroy() {
            //EventBus.$off('READ_QUERY', this.showModal);
            EventBus.$off('DISPATCH_QUERIES', this.fetchQueries);
        }
    }
</script>

<style scoped>
.search{
    width: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
}
.form-control{
  border : 2.3px solid #808080 !important;
  border-radius: 5px !important;
}
</style>
